export default {
  errorMessage: `There was an error playing the camera. Please try again.`,
  productCDN: 'https://wa.cdn-surfline.com/quiver/0.14.2',
};
